import SendIcon from '@mui/icons-material/Send';
import StopCircleIcon from '@mui/icons-material/StopCircle';
import { Box, IconButton, TextField } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

ChatComposer.propTypes = {
	isSending: PropTypes.bool,
	inputRef: PropTypes.object,
	onSend: PropTypes.func.isRequired,
	onStop: PropTypes.func.isRequired,
};

export default function ChatComposer({ isSending, inputRef, onSend, onStop }) {
	const [value, setValue] = useState('');

	const submit = () => {
		if (!value.trim() || isSending) {
			return;
		}
		onSend(value);
		setValue('');
	};

	const onKeyDown = (event) => {
		if (event.key === 'Enter' && !event.shiftKey) {
			event.preventDefault();
			submit();
		}
	};

	return (
		<Box className="border-t border-gray-100 bg-white px-3 pb-2 pt-2">
			<Box className="flex items-end gap-1">
				<TextField
					fullWidth
					multiline
					maxRows={5}
					size="small"
					variant="outlined"
					placeholder="Ask about loans, investors, transactions..."
					inputRef={inputRef}
					inputProps={{ 'aria-label': 'Message' }}
					value={value}
					onChange={(event) => setValue(event.target.value)}
					onKeyDown={onKeyDown}
					sx={{
						'& .MuiOutlinedInput-root': {
							borderRadius: '20px',
							fontSize: '13px',
							padding: '8px 12px',
							backgroundColor: '#f7f7f8',
						},
						'& fieldset': { borderColor: '#e5e7eb' },
					}}
				/>
				{isSending ? (
					<IconButton
						aria-label="Stop"
						onClick={onStop}
						sx={{ color: 'text.secondary' }}>
						<StopCircleIcon />
					</IconButton>
				) : (
					<IconButton
						aria-label="Send"
						disabled={!value.trim()}
						onClick={submit}
						sx={{
							color: 'primary.main',
							'&.Mui-disabled': { color: '#c7c7cc' },
						}}>
						<SendIcon />
					</IconButton>
				)}
			</Box>
			<Box className="px-2 pt-1 text-[10px] text-gray-400">
				Answers come from live platform data — double-check before acting
				on them.
			</Box>
		</Box>
	);
}
